import React from 'react';

// Ikon COD flaticon (cash-on-delivery). Lisensi flaticon free — atribusi di footer.
// PNG 512px di public/icons (bukan SVG inline) agar sama persis dengan pilihan desain.
const CODIcon: React.FC<{ className?: string }> = ({ className }) => (
    <img src="/icons/cod.png" alt="COD" className={className} width={24} height={24} loading="lazy" />
);

export default CODIcon;
